<template>
  <div class="pa-8 flex-column">
    <v-row class="flex-column">
      <v-col cols="12" md="auto">
        <!-- Account Information -->
        <v-card class=" pa-4">
          <v-col cols="12" md="6">
            <img src="@/assets/images/main-logo-dt.png" class="" width="200" />
          </v-col>
          <v-col cols="12" md="6">
            <h1>{{ $t('content.account_information') }}</h1>
          </v-col>

          <v-col cols="12" md="6">
            <h3>{{ $t('form.email') }}</h3>
            <p>{{ user.email || '-' }}</p>
          </v-col>
          <v-col cols="12" md="6">
            <h3>{{ $t('form.phone_number') }}</h3>
            <p>{{ user.phoneNumber || '-' }}</p>
          </v-col>
        </v-card>

        <!-- Account Information -->
        <v-card class="mt-8 pa-4">
          <v-col cols="12" md="6">
            <h1>{{ $t('content.before_you_delete_your_account') }}:</h1>
          </v-col>

          <v-col cols="12" md="6">
            <ol>
              <li v-for="(num, idx) in 6" :key="idx">{{ $t('content.before_delete_account_rule.rule' + (idx + 1)) }}</li>
            </ol>
          </v-col>
        </v-card>
        <v-btn color="success" class="mt-5 mb-10 pa-5" @click="showDeactivateUser">{{ $t('menu.deactive_account') }}</v-btn>
      </v-col>
    </v-row>

    <!-- Dialog Deactivate Class -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('confirmation') }}</v-card-title>
        <v-card-text>{{ $t('delete_user_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDeactivate">{{ $t('no') }}</v-btn>
          <v-btn text :loading="loading" @click="deactivate">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    showDeactivateUser() {
      this.dialog = true;
    },
    cancelDeactivate() {
      this.dialog = false;
    },
    deactivate() {
      this.$store.dispatch('User/deactivate', this.user.userId).then(() => {
        this.$router.push({ name: 'ProfileSuccessDeactivateUser' });
        this.dialog = false;
      });
    }
  }
};
</script>
